import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { getAttachmentIcon, IAttachment } from "@/data/attachments";
import { Col, Flex, IStyleGroupBase, Row } from "@/eworkitComponents";
import { FormikCheckbox } from "@/formikComponents";
import { DownloadButton } from "@/views/components/Files";

import "./_attachments-list.scss";

export interface IAttachmentsListProps extends IStyleGroupBase {
  attachments: IAttachment[];
  selectedAttachments?: IAttachment[];
  onAttachmentCheck?: (attachments: IAttachment[]) => void;
}

interface IAttachmentContentProps {
  attachment: IAttachment;
}

const AttachmentContent: FC<IAttachmentContentProps> = ({ attachment }) => (
  <Flex width={12} justify="space-between" padding={["xs", false, "xs", "xs"]} innerMargin="xs">
    <Text size="md" color="black" text={attachment.name} ellipsis align="left" hjSuppress />
    <Icon size="md" color="grey2" icon="file_download" />
  </Flex>
);

/**
 * @deprecated Use iris-based implementation instead.
 */
export const AttachmentsList: FC<IAttachmentsListProps> = ({
  attachments,
  selectedAttachments,
  onAttachmentCheck,
  padding,
}) => {
  const { t } = useTranslation("session");

  return (
    <Row className="attachments-list" direction="column" grow={1} padding={padding}>
      {attachments.map(attachment => (
        <Col width={12} key={attachment.id} padding={[false, "sm"]}>
          <Flex className="attachments-list__item">
            {Array.isArray(selectedAttachments) && onAttachmentCheck ? (
              <FormikCheckbox
                name="consultantProfile"
                value={attachment.id}
                checked={!!selectedAttachments.find(c => c.id === attachment.id)}
                size="lg"
                onChange={checked => {
                  onAttachmentCheck(
                    checked
                      ? selectedAttachments.concat(attachment)
                      : selectedAttachments.filter(c => c.id !== attachment.id),
                  );
                }}>
                <AttachmentContent attachment={attachment} />
              </FormikCheckbox>
            ) : (
              <DownloadButton
                variant="clean"
                attachment={attachment}
                icon={getAttachmentIcon(attachment.contentType)}
                size="lg">
                <AttachmentContent attachment={attachment} />
              </DownloadButton>
            )}
          </Flex>
        </Col>
      ))}

      {!attachments.length && (
        <Col padding={[false, "sm"]}>
          <Text size="md" color="grey3">
            {t("CONSULTANT_PROFILES.DETAIL.ATTACHMENTS.NO_ITEMS")}
          </Text>
        </Col>
      )}
    </Row>
  );
};
